import { OrderingInitialState, SetMultiPayment } from '@reducers/ordering/types';

export const setMultiPayment = (state: OrderingInitialState, action: SetMultiPayment): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    multiPayment: action?.payload,
  },
});
